import React from 'react';
import { Navigate, useSearchParams } from 'react-router';

export const RedirectToNewAuthPage = () => {
  const [searchParams] = useSearchParams();

  return <Navigate to={`/auth?${searchParams.toString()}`} />;
};
